var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        { attrs: { crumbs: _vm.path } },
        [
          _c("w-input", {
            attrs: {
              value: _vm.name,
              placeholder: _vm.$ct("layout-name-label"),
            },
            on: {
              input: function ($event) {
                return _vm.$emit("update:name", $event)
              },
            },
          }),
          _c("w-spacer"),
          _c(
            "div",
            { staticClass: "v-center" },
            [
              _c(
                "w-button-bar",
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.zoomOut()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search-minus" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.zoomLevelIndex = 3
                        },
                      },
                    },
                    [_vm._v(" [" + _vm._s(_vm.zoomLevel) + "%] ")]
                  ),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.zoomIn()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search-plus" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: !_vm.valid },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  ),
                  _vm.dropDownItems.length > 0
                    ? _c(
                        "w-dropdown",
                        {
                          attrs: { right: "", items: _vm.dropDownItems },
                          on: {
                            click: function ($event) {
                              return $event()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "bars" } })],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-container",
        { staticClass: "container", attrs: { "no-padding": "" } },
        [
          _c(
            "w-row",
            {
              style: {
                flexGrow: 1,
                position: "relative",
                zIndex: 1,
                flexShrink: 1,
                minHeight: 0,
                overflow: "hidden",
              },
              attrs: { "no-margin": "" },
            },
            [
              _c(
                "app-page-container",
                [
                  _c("app-page", {
                    attrs: { layout: _vm.layout, "zoom-level": _vm.zoomLevel },
                  }),
                ],
                1
              ),
              _c("app-tab", { attrs: { tab: _vm.tab, layout: _vm.layout } }),
              _c("app-tabs", {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.uploadJsonModalOpen
        ? _c("app-upload-json-modal", {
            on: {
              close: function ($event) {
                _vm.uploadJsonModalOpen = false
              },
              input: function ($event) {
                return _vm.onNewLayout($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }